module.exports = __webpack_public_path__ + "img/Ginning_1200x800.781d9e34.png";